import React from "react";
import { Tag } from "antd";

import { Modal } from "@components/Page";
import { W1, DRAWER_WIDTH3 } from "@components/Constants";
import { type PersonalAccessToken } from "@api/types";

import getStatusTag from "./helpers/getStatusTag";
import PersonalAccessTokenDetails from "./PersonalAccessTokenDetails";

type Props = {
  personalAccessToken?: PersonalAccessToken;
  isOpen: boolean;
  onClose: () => void;
};

const PersonalAccessTokenDetailsModal = ({
  personalAccessToken,
  isOpen,
  onClose,
}: Props): JSX.Element => {
  const hasToken = !!personalAccessToken;

  const statusTag = hasToken
    ? getStatusTag(personalAccessToken)
    : undefined;

  const tagStyle = {
    marginLeft: W1,
  };

  const title = (
    <>
      {personalAccessToken?.name}

      {statusTag && (
        <Tag color={statusTag.color} style={tagStyle}>
          {statusTag.label}
        </Tag>
      )}
    </>
  );

  const modalProps = {
    title,
    width: DRAWER_WIDTH3,
    isOpen,
    onClose,
  };

  return (
    <Modal {...modalProps}>
      {hasToken
        ? <PersonalAccessTokenDetails personalAccessToken={personalAccessToken} />
        : <></>}
    </Modal>
  );
};

export default PersonalAccessTokenDetailsModal;
